/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import React from "react";
import Head from "next/head";
import Header from "../../common/header/Header";
import Footer from "../../common/footer/Footer";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      h2: "h2",
      ul: "ul",
      li: "li",
      strong: "strong",
      a: "a"
    }, props.components);
    return _jsxs("main", {
      className: "page-wrapper",
      children: [_jsx(Head, {
        children: _jsx("title", {
          children: "Modulabs | Account Ownership"
        })
      }), _jsx(Header, {
        className: "header-not-transparent"
      }), _jsx("div", {
        className: "post-page-banner rn-section-gapTop",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content text-center",
                children: _jsx("div", {
                  className: "page-title",
                  children: _jsx("h1", {
                    className: "theme-gradient",
                    children: "Who owns a Modulabs account?"
                  })
                })
              })
            })
          })
        })
      }), _jsx("div", {
        className: "blog-details-content pt--60 rn-section-gapBottom",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content",
                children: _jsxs("div", {
                  children: [_jsx(_components.p, {
                    children: "Modulabs accounts are owned by individuals, not by organizations. When you sign up and\ncreate an account, you are the owner of that account and all the data in it.\nOur legal responsibility is to the account owner(s), so we won’t let other people take over\nyour account without your permission."
                  }), _jsx(_components.h2, {
                    children: "What can account owners do?"
                  }), _jsx(_components.p, {
                    children: "Account owners can:"
                  }), _jsxs(_components.ul, {
                    children: ["\n", _jsxs(_components.li, {
                      children: [_jsx(_components.strong, {
                        children: "Access and export all data in an account"
                      }), ": account owners can add themselves to any\nTeam or Project and view everything in the account trash. As an account owner, you\ncan also create an HTML export of your Modulabs account data at any time. These exports\nfunction include everything already accessible to you in your Modulabs account. The exports\ndo not include website interaction logs for any account users and we do not provide such\nmeta-data to account owners. For more details, please read our ", _jsx(_components.a, {
                        href: "./privacy",
                        children: "Privacy\npolicy"
                      }), ", which outlines what meta-data we collect and for what\npurposes."]
                    }), "\n", _jsxs(_components.li, {
                      children: [_jsx(_components.strong, {
                        children: "Manage all aspects of the account's subscription:"
                      }), " including updating billing\ninformation; adding more users and account administrators; and cancelling an account."]
                    }), "\n", _jsxs(_components.li, {
                      children: [_jsx(_components.strong, {
                        children: "Designate other account owners"
                      }), ": Modulabs accounts can have multiple\nowners. We recommend designating other owners you trust, so that updates can\nbe made to the account when you're not available."]
                    }), "\n"]
                  }), _jsx(_components.h2, {
                    children: "Designating other people as owners"
                  }), _jsx(_components.p, {
                    children: "An account owner can add or remove other owners from the Adminland section\nin the account. When you designate someone else as an account owner, they will have the same\npower to add and remove other owners (including you) at any time."
                  }), _jsx(_components.p, {
                    children: "Adding a new owner to the account (or being removed as an owner) does not remove the credit\ncard from the account. [Please contact support][mailto:support@modulabs.io] if you’d like to remove the card\nfrom the account before you add a new owner with the intent of being removed as an owner\nyourself."
                  }), _jsx(_components.h2, {
                    children: "What happens when none of the current account owners are available?"
                  }), _jsx(_components.p, {
                    children: "It happens — people switch jobs, get laid off, go on extended leave — the account owner(s)\nmay be unavailable for any number of reasons. Still, our obligation is to the current\naccount owner(s). That means we’re unable to add new owners to the account without\npermission from a current account owner, communicated from the email address we have on\nfile."
                  }), _jsx(_components.p, {
                    children: "If the account has been frozen due to non-payment for less than a week, we’ll be glad to\nthaw the account for a week or so, so people can access their work in the meantime."
                  }), _jsx(_components.p, {
                    children: "The quickest route to add a new owner is often to contact a current account owner, and ask\nthem to log in and add another owner right away from the Adminland section."
                  }), _jsx(_components.p, {
                    children: "Otherwise, we can also gladly reach out to any current account owners at the email addresses\nwe have on file, and request permission to add an owner. If it’s a company address and\nanother employee has access to the inbox, the person who receives the email can grant\npermission to add a new owner. For security’s sake, permission must come from an address we\nhave on file for a current account owner."
                  }), _jsx(_components.p, {
                    children: "When none of the above is an option, a court order is required to add another owner to the\naccount. We will of course readily comply with any court orders to turn data over to the\nappropriate party."
                  }), _jsx(_components.h2, {
                    children: "What if I have another question about ownership?"
                  }), _jsx(_components.p, {
                    children: "Modulabs may update this policy once in a blue moon — we’ll notify you about significant\nchanges by emailing the account owner or by placing a prominent notice on our site. You can\naccess, change or delete your personal information at any time by contacting Modulabs\n[support][mailto:support@modulabs.io]."
                  }), _jsx(_components.p, {
                    children: "Questions about this account ownership policy? Please get in touch with our [support\nteam][mailto:support@modulabs.io] and we’ll be happy to answer them!"
                  }), _jsxs(_components.p, {
                    children: ["Adapted from the ", _jsx(_components.a, {
                      href: "https://github.com/basecamp/policies",
                      children: "Basecamp open-source policies"
                    }), " / ", _jsx(_components.a, {
                      href: "https://creativecommons.org/licenses/by/4.0/",
                      children: "CC\nBY 4.0"
                    })]
                  })]
                })
              })
            })
          })
        })
      }), _jsx(Footer, {})]
    });
  }
}
export default MDXContent;
